import script from "./AdminToast.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminToast.vue?vue&type=script&setup=true&lang=js"

import "./AdminToast.vue?vue&type=style&index=0&id=15cc93af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15cc93af"]])

export default __exports__